<div class="vacancy-maintenance">
  <h1 class="vacancy-maintenance__title">Вакансії: обслуговування</h1>

  <mat-form-field appearance="outline" class="vacancy-maintenance__limit">
    <mat-label>Вакансій за прохід (1–{{ maxLimit }})</mat-label>
    <input matInput type="number" min="1" [max]="maxLimit" [(ngModel)]="limit" />
  </mat-form-field>

  <mat-card class="vacancy-maintenance__card">
    <mat-card-header>
      <mat-card-title>Компетенції вакансій</mat-card-title>
      <mat-card-subtitle
        >Відкриті вакансії, для яких компетенції ще не витягувались. Кожна вакансія — виклик моделі.</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      <div class="vacancy-maintenance__buttons">
        <button
          mat-raised-button
          color="primary"
          (click)="runOnce('competences')"
          [disabled]="runs.competences.running"
        >
          Один прохід
        </button>
        <button mat-stroked-button (click)="runUntilDone('competences')" [disabled]="runs.competences.running">
          {{ runs.competences.running ? 'Виконується...' : 'До кінця' }}
        </button>
      </div>
      @if (runs.competences.passes) {
        <p class="vacancy-maintenance__result">
          Заповнено: {{ runs.competences.filled }} · проходів: {{ runs.competences.passes }}
        </p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="vacancy-maintenance__card">
    <mat-card-header>
      <mat-card-title>Намір зовнішнього пошуку</mat-card-title>
      <mat-card-subtitle
        >Відкриті вакансії з компетенціями, але без наміру пошуку (посада й ключові компетенції).</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      <div class="vacancy-maintenance__buttons">
        <button
          mat-raised-button
          color="primary"
          (click)="runOnce('sourcingIntent')"
          [disabled]="runs.sourcingIntent.running"
        >
          Один прохід
        </button>
        <button mat-stroked-button (click)="runUntilDone('sourcingIntent')" [disabled]="runs.sourcingIntent.running">
          {{ runs.sourcingIntent.running ? 'Виконується...' : 'До кінця' }}
        </button>
      </div>
      @if (runs.sourcingIntent.passes) {
        <p class="vacancy-maintenance__result">
          Заповнено: {{ runs.sourcingIntent.filled }} · проходів: {{ runs.sourcingIntent.passes }}
        </p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="vacancy-maintenance__card">
    <mat-card-header>
      <mat-card-title>Довідник міст robota.ua</mat-card-title>
      <mat-card-subtitle>Перечитати довідник і забути закешовані відповідності міст.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="vacancy-maintenance__buttons">
        <button mat-raised-button color="accent" (click)="syncRobotaUa()" [disabled]="isSyncingRobotaUa">
          {{ isSyncingRobotaUa ? 'Оновлюємо...' : 'Оновити довідник' }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
